// © Microsoft Corporation. All rights reserved.

import { DesignSystem, isDarkMode, neutralFillActive, neutralForegroundHint, neutralForegroundRest } from "@microsoft/fast-components-styles-msft";

import {
    primaryTextColor
} from "../../utils/commonJssConstants";

export const CommentListStyles = (config: DesignSystem) => ({
    commentListHeader: {
        display: "flex",
        "align-items": "center",
        "justify-content": "space-between",
        margin: "24px 0 4px",
        padding: "24px 0 0",
        "border-top": "1px solid #DDDDDD",
        "border-color": neutralFillActive,

        "& .cwt-feedback-btn": {
            "font-size": "14px",
            color: neutralForegroundHint,
            fill: "currentColor",

            "&:hover": {
                color: primaryTextColor,
                fill: "currentColor"
            }
        }
    },
    commentListContent: {
        padding: "0",
        color: neutralForegroundRest,
        "list-style": "none",
        "margin-top": "16px",
        "margin-bottom": "16px"
    },

    commentListContentBlury: {
        overflow: "hidden",
        position: "relative",
        padding: "0 10px",
        margin: "0",

        "&:before": {
            content: "''",
            transition: "background-position 0.2s ease-in, opacity 0.1s linear 0.1s",
            width: "100%",
            height: "100%",
            position: "absolute",
            background: isDarkMode(config) ?  "linear-gradient(180deg, rgba(66, 66, 66, 0), rgba(66, 66, 66, 1))" : "linear-gradient(180deg, rgba(255, 255, 255, 0), #FFFFFF)",
            "background-repeat": "no-repeat",
            opacity: "100%",
            "z-index": "1"
        },
        "&:hover:before": {
            cursor: "pointer",
            "background-position": "0px 100px",
            opacity: "0%"
        }
    }
});